@if (componentData.data$ | async; as component) {
  <div
    class="btn-container"
    [ngClass]="{
      'pb-0': component.removeBottomSpacing | safeCheck,
      'background--dark': component.backgroundColor === 'GREY' | safeCheck,
    }"
  >
    <div class="container">
      <div class="row">
        <div class="col">
          <a
            boelsAnchorButton
            [variant]="'primary-brand'"
            [href]="component.url"
            [target]="component.target | urlTarget"
          >
            {{ component.linkName }}
          </a>
        </div>
      </div>
    </div>
  </div>
}
